export default "__VITE_ASSET__2da2d55b__"